import { render, staticRenderFns } from "./NotificationViewDialog.vue?vue&type=template&id=c1dbd624"
import script from "./NotificationViewDialog.vue?vue&type=script&lang=js"
export * from "./NotificationViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports